<template>
    <div>
        <audio :ref="getAudioRef()" :id="id">
            <source :src="url" type="audio/mpeg">
            {{errorAudio}}
        </audio>
    </div>
</template>

<script>
    export default {
        name: 'AudioPlayer',
        props: {
            id: {
                type: String,
                default: "id-audio-player"
            },
            url: {
                type: String
            },
            autoplay: {
                type: String,
                default: "yes"
            },
            loop: {
                type: String,
                default: "no"
            },
            volume: {
                type: String                
            },
            registered: {
                type: String,
                default: "no"
            },
        },
        data() {
            return {

                // Text
                errorAudio: "Votre navigateur ne prend pas en charge la balise <audio>.",

                // Images


                // Variables

            };
        },
        mounted() {
            
            var thePlayer = this.getAudioPlayer();
            if (thePlayer != null) {
                //console.log("Mounting audio:" + this.getAudioRef());
                thePlayer.addEventListener('play', this.onAudioStarted);
                thePlayer.addEventListener('ended', this.onAudioEnded);
                thePlayer.addEventListener('pause', this.onAudioPaused);

                if (this.volume != null) {
                    var vol = Number(this.volume);
                    thePlayer.volume = vol;
                }

                if (this.autoplay == "yes") {                    
                    this.playAudio();
                }

                // Register this audio to be played again when you press audio button
                // this is automatic if set to autoplay, or the registered flag is used for some
                // special cases               
                if (this.registered == "yes" || (this.autoplay == "yes" && this.loop == "no")) {
                    this.registerAudioIdWithStore(this.id);
                }
            }
        },
        computed: {

        },
        methods: {

            setVolume(vol) {
                var thePlayer = this.$refs[this.getAudioRef()];
                if (thePlayer != null) {
                    thePlayer.volume = vol;
                } else {
                    console.log("Missing audio element: " + this.id);
                }
            },
            getAudioPlayer() {
                var thePlayer = this.$refs[this.getAudioRef()];
                if (thePlayer == null) {
                    alert("Missing audio element: " + this.id);
                }
                return thePlayer;
            },
            getAudioRef() {
                return this.id + "Ref";
            },
            onAudioStarted() {
                this.$emit("audio-started", this.id);
                //console.log("onAudioStarted: " + this.id);
            },
            onAudioEnded() {
                this.$emit("audio-ended", this.id);
                //console.log("onAudioEnded: " + this.id);

                if (this.loop == "yes") {
                    this.playAudio();
                }
            },
            onAudioPaused() {
                this.$emit("audio-paused", this.id);
                //console.log("onAudioPaused: " + this.id);
            },
            playAudio() {
                //console.log("Muted state = " + this.$store.state.gamestate.muted);
                if (this.$store.state.gamestate.muted == true) {
                    return;
                }
                var thePlayer = this.getAudioPlayer();
                if (thePlayer != null) {
                    if (!thePlayer.paused) {
                        thePlayer.load();
                    }
                    thePlayer.play();
                }
            },
            pauseAudio() {
                var thePlayer = this.getAudioPlayer();
                if (thePlayer != null) {
                    thePlayer.pause();
                }
            }
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>

